import { render, staticRenderFns } from "./dish.vue?vue&type=template&id=687232ad&scoped=true&"
import script from "./dish.vue?vue&type=script&lang=js&"
export * from "./dish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687232ad",
  null
  
)

export default component.exports